import {JSX} from "react";

import {HtmlContent} from "@/shared/ui/data-display/html-content";
import {Typography} from "@/shared/ui/data-display/typography";

import "./article-part.scss";

export type ArticlePartProps = {
    title?: string;
    text: string;
};

export function ArticlePart({title, text}: ArticlePartProps): JSX.Element {
    return (
        <article className="article-part">
            {title && (
                <Typography as="h3" size={{desktop: 20, mobile: 18}} weight={500} className="article-part__title">
                    {title}
                </Typography>
            )}

            <HtmlContent html={text} className="article-part__text" />
        </article>
    );
}
